import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import UnpackAdjust from 'components/Sales/Smart/Prepack/unpack/UnpackAdjust';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartUnpackAdjust(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="smart.prepack.unpack.adjust.title" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`Pick By SKU(Pick List)(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <UnpackAdjust />
    </ContentLayout>
  );
}
